import DynamicTable from '../../../../components/DynamicTable/DynamicTable';
import styles from './FeePlan.module.css';
import { useState } from 'react';
import CheckboxAndData from '../../../../components/CheckboxAndData/CheckboxAndData';

function FeePlan() {
  const [tableData, setTableData] = useState([]); // you can populate this dynamically later

  const tableHeadings = [
    { title: <CheckboxAndData />, accessor: 'checkbox' },
    { title: 'Name', accessor: 'name' },
    { title: 'Frequency', accessor: 'frequency' },
    { title: 'Status', accessor: 'status' },
  ];
  return (
    <div className={styles.FeePlan}>
      <DynamicTable
        headings={tableHeadings}
        columnData={tableData}
        noDataMessage="No Fee Plan Assign To Student"
      />
    </div>
  );
}

export default FeePlan;
